import { FunctionComponent, useState, useContext } from 'react';

import './Header.style.css';
import { CSVLink } from 'react-csv';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import Button from '../Button/Button.component';
import { FilterContext } from '../../contexts/FilterContext';
import {
	handleDownloadRawFreqCSV,
	handleDownloadTrendlineCSV,
	handleSharingClick,
	handleSVGDownload,
} from '../SharingContainer/SharingContainer.utils';

interface HeaderProps {
	graphData: { key: string; values: { x: string; y: number }[] }[];
	rawFrequencyData: { x: string; y: number }[];
}

const Header: FunctionComponent<HeaderProps> = ({
	graphData,
	rawFrequencyData,
}) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [isCopyModalShown, setIsCopyModalShown] = useState(false);
	const [filters] = useContext(FilterContext);
	const { graphViewmode, yearSpan } = filters;
	const hasData = graphData.length > 0 || rawFrequencyData.length > 0;

	const getWidth = () => {
		const backLink = document.querySelector('.logo-title-container__link');
		const width = backLink ? backLink.clientWidth : 0;
		return width;
	};

	return (
		<header className="header">
			<div className="header__wrapper">
				<div className="logo-title-container">
					<a
						style={{ left: `-${getWidth()}px` }}
						href="https://www.nb.no/"
						target="_blank"
						className="logo-title-container__link"
						aria-label="Gå tilbake til nb.no"
						rel="noreferrer"
					>
						Til nb.no
					</a>
					<Logo />
					<h1>Nasjonalbiblioteket </h1>
					<span className="gray-text">| N-gram</span>
				</div>
				<div className="search-dropdown-wrapper">
					<div className="dropdown">
						<Button
							buttonLabel="Delingsalternativer"
							className={`dropdown-button ${
								isDropdownOpen && 'dropdown-open'
							}`}
							borderLess
							onClick={() => setIsDropdownOpen(!isDropdownOpen)}
						/>
						<div
							className={`dropdown-content ${
								isDropdownOpen && 'dropdown-open'
							}`}
						>
							{hasData && graphViewmode !== 'galakser' && (
								<CSVLink
									data={
										graphViewmode === 'trendlinjer'
											? handleDownloadTrendlineCSV(
													graphData,
													yearSpan,
											  )
											: handleDownloadRawFreqCSV(
													rawFrequencyData,
											  )
									}
									separator={','}
									target="_blank"
									filename={'n-gram-data.csv'}
									className="sharing-link"
								>
									Rådata (.csv)
								</CSVLink>
							)}

							{graphViewmode !== 'galakser' && (
								<button
									onClick={handleSVGDownload}
									className="sharing-link"
								>
									Grafikk (.svg)
								</button>
							)}
							<a
								href="https://www.nb.no/sprakbanken/ressurskatalog/oai-nb-no-sbr-76/"
								target="_blank"
								className="sharing-link"
								rel="noreferrer"
							>
								Korpuset i sin helhet
							</a>
							<button
								className="sharing-link"
								onClick={() => {
									handleSharingClick();
									setIsCopyModalShown(true);
									setTimeout(() => {
										setIsCopyModalShown(false);
									}, 1500);
								}}
							>
								{isCopyModalShown
									? 'Lenken ble kopiert til utklippstavlen.'
									: 'Kopier lenken til n-grammet'}
							</button>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
